import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  secretKey = "2118043693022477524248759259662940440864000098715191458227798849862513643295051098241337428310980917";
  isEncryption = true;
  constructor() {
  }

  encrypt(value: any) {
    if(this.isEncryption) {
      return CryptoJS.AES.encrypt(JSON.stringify(value), this.secretKey.trim()).toString();
    } else {
      return value
    }
  }

  decrypt(textToDecrypt: any) {
    if(this.isEncryption) {
      return JSON.parse(CryptoJS.AES.decrypt(textToDecrypt, this.secretKey.trim()).toString(CryptoJS.enc.Utf8));
    } else {
      return textToDecrypt
    }
  }
}
